<script setup lang="ts">
	import type { ClassNameValue } from 'tailwind-merge'

	withDefaults(
		defineProps<{
			text?: string | number
			variant?: ComponentsVariant
			rounded?: boolean
			success?: boolean
			failed?: boolean
			pending?: boolean
			active?: boolean
			paused?: boolean
			resolved?: boolean
			unresolved?: boolean
			waiting?: boolean
			expired?: boolean
			inactive?: boolean
			churned?: boolean
			terminated?: boolean
			deactivated?: boolean
			ongoing?: boolean
		}>(),
		{
			rounded: false,
			success: false,
			failed: false,
			pending: false,
			active: false,
			paused: false,
			resolved: false,
			waiting: false,
			expired: false,
			inactive: false,
			churned: false,
			terminated: false,
			deactivated: false,
			ongoing: false
		}
	)
	const attr = useAttrs()
	const clsName = String(attr?.class as ClassNameValue)
</script>

<template>
	<span
		:class="
			cn(
				'w-auto truncate px-[6px] py-[2px] text-[10px] font-medium leading-[12px]',
				rounded ? 'rounded-[20px]' : 'rounded-[4px]',
				variant === 'primary' ? 'bg-primary-250 text-primary-2' : '',
				variant === 'success' || success || active || resolved ? 'bg-success-50 text-success-500' : '',
				variant === 'purple' ? 'bg-purple-100 text-purple-500' : '',
				variant === 'blue' || waiting || ongoing ? 'bg-blue-50 text-blue-500' : '',
				variant === 'orange' ? 'bg-orange-100 text-orange-500' : '',
				variant === 'pink' ? 'bg-pink-100 text-pink-500' : '',
				variant === 'warning' || pending || paused ? 'bg-warning-50 text-warning-500' : '',
				deactivated || inactive ? 'bg-gray-200 text-gray-500' : '',
				variant === 'gray' ? 'bg-gray-200 text-gray-500' : '',

				variant === 'error' || failed || unresolved || expired || churned || terminated
					? 'bg-error-50 text-error-500'
					: '',
				clsName
			)
		"
	>
		<slot>
			{{ text }}
		</slot>
	</span>
</template>
